import type {Checkout} from '@wix/ambassador-checkout/types'
import type {CartSummary, CreateCartResponse} from '@wix/ambassador-ecom-v2-cart/types'
import type {Order} from '@wix/ambassador-ep-orders/types'

export const isFreeCheckout = (checkout: Checkout) => {
  return Number(checkout.priceSummary!.total!.amount) === 0
}

export const isFreeOrder = (order: Order) => {
  return Number(order.priceSummary!.total!.amount) === 0
}

export const hasPrepaidOrder = (order?: Order | null) => {
  const subtotal = Number(order?.priceSummary?.subtotal?.amount)
  const lineItem = Number(order?.lineItems?.[0]?.lineItemPrice?.amount)

  if ((Number.isFinite(subtotal) && subtotal > 0) || (Number.isFinite(lineItem) && lineItem > 0)) {
    return true
  }

  const paid = Number(order?.balanceSummary?.paid?.amount)
  const refunded = Number(order?.balanceSummary?.refunded?.amount)
  const pendingRefund = Number(order?.balanceSummary?.pendingRefund?.amount)

  if (!Number.isFinite(paid) || paid <= 0) {
    return false
  }

  if (Number.isFinite(refunded) && refunded > 0) {
    return true
  }

  return Number.isFinite(pendingRefund) && pendingRefund > 0
}

const isPositiveAmount = (amount?: string) => Number(amount ?? 0) > 0

export const isCartPaymentRequired = (cartResponse: CreateCartResponse) => {
  return isPositiveAmount(cartResponse.cart?.subtotal?.amount)
}

const isZeroAmount = (amount?: string | null) =>
  Number.isFinite(Number(amount)) && Number(amount) === 0

export const isFreeCartSummary = (summary?: CartSummary) => {
  const paymentSummary = summary?.paymentSummary

  if (!summary || !paymentSummary || paymentSummary.requiresPaymentAfterGiftCard) {
    return false
  }

  if (summary.violations?.length) {
    return false
  }

  const {payNow, payLater} = paymentSummary

  return (!payNow || isZeroAmount(payNow.amount)) && (!payLater || isZeroAmount(payLater.amount))
}
